<template>
  <svg
    id="svg"
    :fill="fill"
    width="200px"
    height="200px"
    version="1.1"
    viewBox="144 144 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconSvg_bgCarrier" stroke-width="0"></g>
    <g
      id="IconSvg_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="#CCCCCC"
    ></g>
    <g id="IconSvg_iconCarrier">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="m619.4 343.18c-17.492-6.5078-21.996 15.277-27.367 26.582-8.6523 16.746-20.477 32.398-35.082 44.406-16.629 13.441-35.469 24.633-56.496 29.582 52.648-52.707 60.703-126.93 33.691-194.11-9.9219-24.652-26.625-47.117-46.586-64.527-9.0469-7.9102-24.441-8.793-28.078 5.6289-2.7812 11.012 8.8203 20.512 14.531 28.777 21.543 33.562 29.918 77.598 18.293 116.29-18.828-70.16-77.5-115.12-147.7-125.72-26.129-3.25-53.637-2.3477-78.777 6.2109-10.68 3.6641-23.23 11.133-16.062 24.641 6.3281 11.906 18.816 7.0078 29.227 6.1367 41.805-3.3594 86.535 10.762 115.74 41.832-71.969-19.27-140.32 10.953-184.95 67.887-16.41 20.934-27.438 46.602-32.59 72.609-2.3242 11.773 4.6094 25.559 18.914 21.508 10.926-3.0938 13.355-17.906 17.66-26.973 18.258-35.383 52.27-64.73 91.566-73.988-52.68 52.668-60.688 126.95-33.684 194.12 9.9062 24.625 26.617 47.148 46.594 64.523 9.043 7.8984 24.441 8.7852 28.078-5.6289 2.793-11.023-8.8281-20.5-14.52-28.789-21.539-33.527-29.961-77.617-18.305-116.29 18.812 70.16 77.5 115.12 147.69 125.73 26.129 3.2461 53.637 2.3477 78.77-6.2188 10.676-3.6484 23.234-11.133 16.055-24.637-6.3164-11.898-18.801-7.0039-29.215-6.1406-41.84 3.3555-86.488-10.766-115.74-41.828 45.816 12.262 93.098 4.9883 132.96-19.992 20.262-12.707 37.281-29.137 51.992-47.906 9.9141-12.637 53.375-82.555 23.387-93.715-8.1016-3.0078 7.2812 2.7031 0 0z"
      ></path>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'texture-panel',
    props: ['fill'],
  }
</script>
